import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntBasicHB } from "../../../../../models/handBooks/basicHB";
import {
  useAddFarmCategoryMutation,
  useDeleteFarmCategoryMutation,
  useEditFarmCategoryMutation
} from "../../../../../redux/api/handBooksApi/organic/farmCategoryApi";

const useFarmCategory = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [addFarmCategory] = useAddFarmCategoryMutation();
  const [deleteFarmCategory] = useDeleteFarmCategoryMutation();
  const [editFarmCategory] = useEditFarmCategoryMutation();

  async function onAddFarmCategory(newFarmCategory: EntBasicHB): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addFarmCategory(newFarmCategory).then((response: any) => {
		if (response.error !== undefined) {

		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onDeleteFarmCategory(farmCategory: EntBasicHB) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteFarmCategory(farmCategory.id).then((response: any) => {
			if (response.error !== undefined && response.error.status === 400) {
			  status = false;
			  throw new Error(response.error.data.message);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({ title: t('msg.successDelete') });
			  if (refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };

  async function onEditFarmCategory(editedFarmCategory: EntBasicHB): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editFarmCategory(editedFarmCategory).then((response: any) => {
		if (response.error !== undefined && response.error.status === 400) {
		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({ title: t('msg.successEdited') });
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };
  return { onAddFarmCategory, onDeleteFarmCategory, onEditFarmCategory }

}
export { useFarmCategory };

